import {useState,useEffect} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Header from '../../components/header'
import Footer from '../../components/footer'
import { FaFacebook, FaInstagram, FaLinkedin, FaResearchgate, FaGraduationCap,FaLock } from 'react-icons/fa';
import axios from 'axios'
const BASE_URL = process.env.REACT_APP_BASE_URL;
const TeacherProfilePublicView = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const [pdfModal,setPdfModal]=useState()
  const [videoModal,setVideoModal]=useState()
  
  const [teacherData, setTeacherData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab,setActiveTab]=useState('courses')
  // console.log("teacherData",teacherData)
  useEffect(() => {
    if (!id) return;

    const fetchTeacherData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${BASE_URL}/teacher/public/${id}`,{
           headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        });
        setTeacherData(res.data);
      } catch (err) {
        console.error(err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchTeacherData();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <>
      <Header/>

      <div className=" mx-auto px-4 sm:px-6 lg:px-8 font-inter">
  <div className="py-8 md:py-6 min-h-screen">
    {/* TOP CARD */}
    <div className="bg-white rounded-2xl p-2 md:p-6 md:p-8 border border-gray-200 mb-10 shadow-sm">
      {/* Instructor Header */}
 <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-8">

  {/* IMAGE */}
  <div className="w-32 h-32 rounded-full overflow-hidden flex-shrink-0 border-4 border-white shadow-lg">
    <img
      src={teacherData.user.profile_image}
      alt="Instructor"
      className="w-full h-full object-cover"
    />
  </div>

  {/* TEXT */}
  <div className="flex-1 text-center md:text-left">
    <div className="flex items-center justify-center md:justify-start gap-3 mb-2">
      {/* <div className="w-1.5 h-6 bg-[#0f6abf] rounded-full"></div> */}
      <h1 className="text-3xl md:text-2xl font-bold text-gray-900">
        {teacherData.user.name}
      </h1>
    </div>

    <p className="text-gray-600 leading-relaxed">
      {Array.isArray(teacherData.experiences) &&
      teacherData.experiences.length > 0
        ? teacherData.experiences[0].experienceDescription
        : "No experience available"}
    </p>
  </div>

</div>



      {/* INFO GRID */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 mt-6">
        {/* EXPERIENCE SECTION */}
        <div className="bg-white rounded-xl p-2 md:p-6 border border-gray-200">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Experiences</h3>
          </div>
          {teacherData.experiences?.length > 0 ? (
            <div className="space-y-4">
              {teacherData.experiences.map((exp, index) => (
                <div key={index} className="flex gap-3 p-3 bg-gray-50 rounded-xl">
                  <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-gray-600">📌</span>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-900 mb-1">{exp.experienceYears} years</p>
                    <p className="text-sm text-gray-600">{exp.experienceDescription}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="p-4 bg-gray-50 rounded-xl text-center">
              <p className="text-sm text-gray-500">No experiences added yet</p>
            </div>
          )}
        </div>

        {/* SOCIALS SECTION */}
        <div className="bg-white rounded-xl p-2 md:p-6 border border-gray-200">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Social Links</h3>
          </div>
          <div className="flex flex-wrap gap-3">
            {teacherData.socials.facebook && (
              <a 
                href={teacherData.socials.facebook} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center w-20 h-20 rounded-xl bg-gray-50 border border-gray-200 hover:bg-[#1877F2] hover:text-white hover:border-[#1877F2] transition-all p-3 group"
              >
                <FaFacebook className="text-2xl mb-1 text-[#1877F2] group-hover:text-white" />
                <span className="text-xs font-medium text-gray-600 group-hover:text-white">Facebook</span>
              </a>
            )}
            {teacherData.socials.insta && (
              <a 
                href={teacherData.socials.insta} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center w-20 h-20 rounded-xl bg-gray-50 border border-gray-200 hover:bg-gradient-to-br hover:from-[#405de6] hover:via-[#833ab4] hover:to-[#fd1d1d] hover:text-white hover:border-transparent transition-all p-3 group"
              >
                <FaInstagram className="text-2xl mb-1 text-[#E4405F] group-hover:text-white" />
                <span className="text-xs font-medium text-gray-600 group-hover:text-white">Instagram</span>
              </a>
            )}
            {teacherData.socials.linkedin && (
              <a 
                href={teacherData.socials.linkedin} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center w-20 h-20 rounded-xl bg-gray-50 border border-gray-200 hover:bg-[#0A66C2] hover:text-white hover:border-[#0A66C2] transition-all p-3 group"
              >
                <FaLinkedin className="text-2xl mb-1 text-[#0A66C2] group-hover:text-white" />
                <span className="text-xs font-medium text-gray-600 group-hover:text-white">LinkedIn</span>
              </a>
            )}
            {teacherData.socials.researchgate && (
              <a 
                href={teacherData.socials.researchgate} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center w-20 h-20 rounded-xl bg-gray-50 border border-gray-200 hover:bg-[#00CCBB] hover:text-white hover:border-[#00CCBB] transition-all p-3 group"
              >
                <FaResearchgate className="text-2xl mb-1 text-[#00CCBB] group-hover:text-white" />
                <span className="text-xs font-medium text-gray-600 group-hover:text-white">ResGate</span>
              </a>
            )}
            {teacherData.socials.ieee && (
              <a 
                href={teacherData.socials.ieee} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center w-20 h-20 rounded-xl bg-gray-50 border border-gray-200 hover:bg-[#00629B] hover:text-white hover:border-[#00629B] transition-all p-3 group"
              >
                <FaGraduationCap className="text-2xl mb-1 text-[#00629B] group-hover:text-white" />
                <span className="text-xs font-medium text-gray-600 group-hover:text-white">IEEE</span>
              </a>
            )}
          </div>
        </div>

        {/* SUBJECTS */}
        <div className="bg-white rounded-xl p-2 md:p-6 border border-gray-200">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Subjects</h3>
          </div>
          <div className="flex flex-wrap gap-2">
            {teacherData.subjects.map((subject, index) => (
              <div 
                key={index} 
                className={`px-3 py-1.5 rounded-lg text-xs font-medium flex items-center gap-1 ${
                  subject.certification === "Yes" 
                    ? 'bg-green-50 text-green-700 border border-green-200' 
                    : 'bg-blue-50 text-blue-700 border border-blue-200'
                }`}
              >
                {subject.name}
                {subject.certification === "Yes" && "✅"}
              </div>
            ))}
          </div>
        </div>

        {/* LANGUAGES */}
        <div className="bg-white rounded-xl p-2 md:p-6 border border-gray-200">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Languages</h3>
          </div>
          <div className="flex flex-wrap gap-2">
            {teacherData.languages.map((language, index) => (
              <div key={index} className="px-3 py-1.5 bg-purple-50 text-purple-700 border border-purple-200 rounded-lg text-xs font-medium">
                {language}
              </div>
            ))}
          </div>
        </div>

        {/* SKILLS */}
        <div className="bg-white rounded-xl p-2 md:p-6 border border-gray-200">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Skills</h3>
          </div>
          <div className="space-y-2">
            {teacherData.skills.map((skill, index) => {
              const levelColors = {
                beginner: 'bg-amber-50 text-amber-700 border-amber-200',
                intermediate: 'bg-blue-50 text-blue-700 border-blue-200',
                advanced: 'bg-indigo-50 text-indigo-700 border-indigo-200',
                expert: 'bg-violet-50 text-violet-700 border-violet-200',
                master: 'bg-pink-50 text-pink-700 border-pink-200'
              };
              const levelClass = levelColors[skill.level.toLowerCase()] || 'bg-gray-50 text-gray-700 border-gray-200';
              
              return (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                  <span className="text-sm font-medium text-gray-900">{skill.skill}</span>
                  <span className={`text-xs px-2.5 py-1 rounded-lg border font-medium ${levelClass}`}>
                    {skill.level}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        {/* RESOURCES */}
        <div className="bg-white rounded-xl p-2 md:p-6 border border-gray-200">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Resources</h3>
          </div>
          <div className="space-y-3">
            {teacherData.portfolios?.map((portfolio) => (
              <div 
                key={portfolio.id}
                onClick={() => setPdfModal(portfolio?.file)}
                className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl border border-gray-200 hover:bg-gray-100 hover:border-gray-300 transition-all cursor-pointer"
              >
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-gray-600">📁</span>
                </div>
                <span className="flex-1 text-sm font-medium text-gray-900">View Portfolio</span>
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            ))}
            {teacherData.videos?.map((video) => (
              <div 
                key={video.id}
                onClick={() => setPdfModal(video?.file)}
                className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl border border-gray-200 hover:bg-gray-100 hover:border-gray-300 transition-all cursor-pointer"
              >
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-gray-600">🎬</span>
                </div>
                <span className="flex-1 text-sm font-medium text-gray-900">Watch Introduction Video</span>
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    {/* Tabs Section */}
    <div className="flex gap-2 mb-6">
      {['courses', 'videos', 'audios', 'podcasts'].map((tab) => (
        <button
          key={tab}
          className={`px-5 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${
            activeTab === tab 
              ? 'bg-[#0f6abf] text-white shadow-sm' 
              : 'bg-gray-50 text-gray-600 border border-gray-300 hover:border-[#0f6abf] hover:text-[#0f6abf]'
          }`}
          onClick={() => setActiveTab(tab)}
        >
          {tab.charAt(0).toUpperCase() + tab.slice(1)}
        </button>
      ))}
    </div>

    {/* CONTENT SECTIONS */}
    {activeTab === 'courses' && (
      <div className="mt-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1.5 h-6 bg-[#0f6abf] rounded-full"></div>
          <h2 className="text-2xl font-bold text-gray-900">My Courses</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {teacherData.courses?.map((course) => (
            <div 
              key={course.id}
              className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:border-[#0f6abf] hover:shadow-lg transition-all cursor-pointer"
              onClick={() => navigate(`/course/${course.teacher}/${course.learning_type}/${course.id}`)}
            >
              <img 
                src={course.image}
                alt="course" 
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">{course.name}</h3>
                <p className="text-sm text-gray-600 line-clamp-3">
                  {course.description.length > 150
                    ? course.description.slice(0, 150) + "..."
                    : course.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    {activeTab === 'videos' && (
      <div className="mt-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1.5 h-6 bg-[#0f6abf] rounded-full"></div>
          <h2 className="text-2xl font-bold text-gray-900">My Videos</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {teacherData.vvideos?.map((course) => (
            <div 
              key={course.id}
              className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:border-[#0f6abf] hover:shadow-lg transition-all cursor-pointer"
              onClick={() => navigate(`/course/${course.teacher}/${course.learning_type}/${course.id}`)}
            >
              <div className="relative w-full bg-black">
                <video
                  src={course.file}
                  className="w-full h-48 object-cover"
                  controls={course.payment_status === "paid" || course.course_type === "free"}
                />
                {course.payment_status !== "paid" && course.course_type !== "free" && (
                  <div
                    className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center"
                    onClick={(e) => {
                      e.stopPropagation();
                      alert("Payment required to play this video");
                    }}
                  >
                    <FaLock className="text-white text-3xl mb-2" />
                    <span className="text-white text-sm font-medium">Locked</span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">{course.name}</h3>
                <p className="text-sm text-gray-600 line-clamp-3">
                  {course.description.length > 150
                    ? course.description.slice(0, 150) + "..."
                    : course.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    {activeTab === 'audios' && (
      <div className="mt-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1.5 h-6 bg-[#0f6abf] rounded-full"></div>
          <h2 className="text-2xl font-bold text-gray-900">My Audios</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {teacherData.audios?.map((course) => (
            <div 
              key={course.id}
              className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:border-[#0f6abf] hover:shadow-lg transition-all cursor-pointer"
              onClick={() => navigate(`/course/${course.teacher}/${course.learning_type}/${course.id}`)}
            >
              <div className="relative w-full p-4 bg-gray-50">
                <audio
                  src={course.file}
                  className="w-full"
                  controls={course.payment_status === "paid" || course.course_type === "free"}
                />
                {course.payment_status !== "paid" && course.course_type !== "free" && (
                  <div
                    className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center rounded-t-xl"
                    onClick={(e) => {
                      e.stopPropagation();
                      alert("Payment required to play this audio");
                    }}
                  >
                    <FaLock className="text-white text-3xl mb-2" />
                    <span className="text-white text-sm font-medium">Locked</span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">{course.name}</h3>
                <p className="text-sm text-gray-600 line-clamp-3">
                  {course.description.length > 150
                    ? course.description.slice(0, 150) + "..."
                    : course.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    {activeTab === 'podcasts' && (
      <div className="mt-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1.5 h-6 bg-[#0f6abf] rounded-full"></div>
          <h2 className="text-2xl font-bold text-gray-900">My Podcasts</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {teacherData.podcasts?.map((course) => (
            <div 
              key={course.id}
              className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:border-[#0f6abf] hover:shadow-lg transition-all cursor-pointer"
              onClick={() => navigate(`/course/${course.teacher}/${course.learning_type}/${course.id}`)}
            >
              <div className="relative w-full bg-black">
                <video
                  src={course.file}
                  className="w-full h-48 object-cover"
                  controls={course.payment_status === "paid" || course.course_type === "free"}
                />
                {course.payment_status !== "paid" && course.course_type !== "free" && (
                  <div
                    className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center"
                    onClick={(e) => {
                      e.stopPropagation();
                      alert("Payment required to play this video");
                    }}
                  >
                    <FaLock className="text-white text-3xl mb-2" />
                    <span className="text-white text-sm font-medium">Locked</span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">{course.name}</h3>
                <p className="text-sm text-gray-600 line-clamp-3">
                  {course.description.length > 150
                    ? course.description.slice(0, 150) + "..."
                    : course.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>

  {/* Loading State */}
  {loading && (
    <div className="flex justify-center items-center min-h-[300px]">
      <div className="w-10 h-10 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
    </div>
  )}

  {/* Empty State */}
  {!loading && teacherData.courses?.length === 0 && (
    <div className="text-center py-12 px-4 bg-gray-50 rounded-2xl">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1">No courses found</h3>
      <p className="text-gray-500">This instructor hasn't added any courses yet.</p>
    </div>
  )}
</div>
      {pdfModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4">
    <div className="bg-white rounded-2xl w-full max-w-6xl h-[90vh] shadow-xl flex flex-col overflow-hidden">

      {/* Header */}
      <div className="flex items-center justify-between p-6 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Document Viewer</h3>
            <p className="text-sm text-gray-500 mt-0.5">PDF Preview</p>
          </div>
        </div>
        <button
          onClick={() => setPdfModal(null)}
          className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
        >
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* PDF iframe */}
      <div className="flex-1 p-6 bg-gray-50">
        <iframe
          src={pdfModal}
          title="PDF Viewer"
          className="w-full h-full border-none rounded-xl bg-white shadow-sm"
        />
      </div>
    </div>
  </div>
)}

{videoModal && (
  <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[1000] p-4">
    <div className="relative w-full max-w-5xl bg-white rounded-2xl shadow-2xl overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
            <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-900">Video Player</h3>
        </div>
        <button
          onClick={() => setVideoModal(null)}
          className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
        >
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Video Player */}
      <div className="p-4 bg-black/5">
        <video
          src={videoModal}
          controls
          autoPlay
          className="w-full h-full max-h-[70vh] object-contain rounded-xl mx-auto"
        />
      </div>
    </div>
  </div>
)}

      <Footer/>
    </>
  )
}

export default TeacherProfilePublicView
